var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 246,
    height: 101,
    viewBox: "0 0 246 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 101
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_3",
    "data-name": "Artboard \\u2013 3",
    clipPath: "url(#clip-Artboard_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 101,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo_neo",
    "data-name": "logo neo",
    transform: "translate(20.562 23.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M81.556,40.987l-2.321,7.476H77.98l-1.631-5.1a3.765,3.765,0,0,1-.125-.46l-.063.24a.972.972,0,0,1-.073.209l-1.642,5.113H73.192l-2.3-7.476h1.161a.429.429,0,0,1,.3.084.418.418,0,0,1,.167.23L73.8,45.776a.66.66,0,0,0,.073.356c.073.125,0,.272.084.408l.094-.408a2.875,2.875,0,0,1,.1-.356L75.617,41.3a.533.533,0,0,1,.157-.22.5.5,0,0,1,.3-.094h.408a.481.481,0,0,1,.293.084.6.6,0,0,1,.167.23l1.474,4.475a5.971,5.971,0,0,1,.2.742,3.114,3.114,0,0,1,.146-.742L80.04,41.3a.376.376,0,0,1,.157-.22.544.544,0,0,1,.314-.094Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M83.763,42.1v2.091h2.614v1.046H83.763v2.091h3.315v1.108H82.361V40.987h4.716V42.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M98.641,40.987v7.476H97.418V43.005L95.149,47.25a.523.523,0,0,1-.491.314h-.2a.523.523,0,0,1-.491-.314l-2.279-4.256v5.468h-1.15V40.987h1.328a.324.324,0,0,1,.094.073.376.376,0,0,1,.084.125l2.248,4.182.157.345a3.61,3.61,0,0,1,.146.356l.157-.366a3.192,3.192,0,0,1,.157-.345l2.217-4.182a.377.377,0,0,1,.084-.125l.1-.073h1.328Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M106.577,48.463h-1.046a.46.46,0,0,1-.3-.084.627.627,0,0,1-.167-.23l-.554-1.527h-3.084l-.554,1.527a.47.47,0,0,1-.157.22.429.429,0,0,1-.293.094H99.331l2.938-7.476h1.412ZM104.12,45.64l-.91-2.478a1.56,1.56,0,0,0-.146-.4c-.052-.146-.094-.314-.146-.491a1.559,1.559,0,0,1-.136.491c-.052.157-.094.293-.136.4l-.91,2.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M108.6,44.124h.324a1.108,1.108,0,0,0,.324-.052.648.648,0,0,0,.23-.178l2.091-2.614a.732.732,0,0,1,.272-.23,1.046,1.046,0,0,1,.355-.063h1.2l-2.52,3.137a1.558,1.558,0,0,1-.46.408,1.129,1.129,0,0,1,.314.167,1.746,1.746,0,0,1,.261.293l2.593,3.5H112.36a.659.659,0,0,1-.376-.073.5.5,0,0,1-.209-.209l-2.091-2.76a.512.512,0,0,0-.23-.188.889.889,0,0,0-.376-.063h-.439v3.294h-1.391V40.977h1.391Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M115.549,42.1v2.091h2.6v1.046h-2.614v2.091h3.315v1.108h-4.716V40.987h4.716V42.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M124.75,40.987a4.182,4.182,0,0,1,1.3.178,2.342,2.342,0,0,1,.91.491,2.018,2.018,0,0,1,.533.753,2.52,2.52,0,0,1,.167.962,2.457,2.457,0,0,1-.178,1.046,2.091,2.091,0,0,1-.544.784,2.509,2.509,0,0,1-.91.5,4.329,4.329,0,0,1-1.276.188H123.7v2.624h-1.37V40.987Zm0,3.764a2.4,2.4,0,0,0,.669-.094,1.182,1.182,0,0,0,.471-.272,1.046,1.046,0,0,0,.282-.439,1.725,1.725,0,0,0,.094-.565,1.568,1.568,0,0,0-.094-.544.941.941,0,0,0-.272-.418,1.234,1.234,0,0,0-.471-.261,1.882,1.882,0,0,0-.68-.094H123.7v2.687Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M134.882,40.987v7.476h-1.391V45.2h-3.513v3.262h-1.37V40.987h1.4v3.22h3.513v-3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M142.807,48.463h-1.046a.429.429,0,0,1-.3-.084.627.627,0,0,1-.167-.23l-.554-1.527H137.6l-.554,1.527a.47.47,0,0,1-.157.22.439.439,0,0,1-.3.094H135.54l2.938-7.476h1.412ZM140.35,45.64l-.91-2.478-.136-.4a1.988,1.988,0,0,0-.146-.491,1.9,1.9,0,0,1-.136.491,3.283,3.283,0,0,1-.146.4l-.857,2.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M149.279,48.463h-1.255a.544.544,0,0,1-.512-.272L145.944,45.8a.606.606,0,0,0-.2-.2.638.638,0,0,0-.314,0h-.6v2.928h-1.391V40.987h2.279a4.611,4.611,0,0,1,1.307.157,2.384,2.384,0,0,1,.889.45,1.673,1.673,0,0,1,.523.68,2.206,2.206,0,0,1,.157.868,2.091,2.091,0,0,1-.429,1.328,2.478,2.478,0,0,1-.512.481,3.032,3.032,0,0,1-.7.324l.24.178a.952.952,0,0,1,.209.251ZM145.7,44.553a2.143,2.143,0,0,0,.68-.1,1.223,1.223,0,0,0,.481-.272,1.1,1.1,0,0,0,.282-.408,1.5,1.5,0,0,0,.094-.523,1.046,1.046,0,0,0-.376-.878,1.788,1.788,0,0,0-1.15-.3h-.878v2.489Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M158.062,40.987v7.476h-1.223V43.005l-2.258,4.245a.523.523,0,0,1-.491.314h-.2a.533.533,0,0,1-.491-.314l-2.279-4.256v5.468H149.9V40.987h1.328l.1.073a.377.377,0,0,1,.084.125l2.238,4.182a3.511,3.511,0,0,1,.167.345,1.114,1.114,0,0,0,.146.356,3.813,3.813,0,0,1,.146-.366,2.645,2.645,0,0,1,.167-.345l2.206-4.182a.376.376,0,0,1,.084-.125l.1-.073h1.338Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M165.988,48.463h-1.046a.418.418,0,0,1-.293-.084.648.648,0,0,1-.178-.23l-.554-1.527h-3.137l-.565,1.527a.47.47,0,0,1-.157.22.429.429,0,0,1-.293.094h-1.046l2.938-7.476h1.422Zm-2.457-2.823-.91-2.478-.146-.4a2.5,2.5,0,0,0-.136-.491,1.574,1.574,0,0,1-.146.491,3.449,3.449,0,0,1-.136.4l-.91,2.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M171.216,40.987a4.632,4.632,0,0,1,1.255.146,2.468,2.468,0,0,1,.857.4,1.516,1.516,0,0,1,.481.627,1.871,1.871,0,0,1,.157.826,1.663,1.663,0,0,1-.073.5,1.433,1.433,0,0,1-.24.45,1.8,1.8,0,0,1-.418.376,2.624,2.624,0,0,1-.6.293q1.537.345,1.537,1.662a2.092,2.092,0,0,1-.178.878,1.924,1.924,0,0,1-.523.7,2.437,2.437,0,0,1-.857.46,3.921,3.921,0,0,1-1.15.167h-2.823V40.987Zm-1.182,1.046v2.2h1.046a1.861,1.861,0,0,0,1.046-.261.9.9,0,0,0,.366-.826.951.951,0,0,0-.324-.836,1.725,1.725,0,0,0-1.046-.24Zm1.443,5.343a1.945,1.945,0,0,0,.648-.084,1.046,1.046,0,0,0,.4-.24.91.91,0,0,0,.23-.366,1.254,1.254,0,0,0,.073-.439,1.285,1.285,0,0,0-.073-.439.763.763,0,0,0-.251-.324.983.983,0,0,0-.418-.209,2.144,2.144,0,0,0-.627-.073h-1.4v2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M176.705,42.1v2.091h2.614v1.046h-2.614v2.091h3.315v1.108H175.3V40.987h4.716V42.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M186.335,42.127h-2.258v6.336h-1.391V42.127h-2.258v-1.14h5.908Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M192.389,42.127h-2.258v6.336H188.74V42.127h-2.258v-1.14h5.908Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M194.627,42.1v2.091h2.614v1.046h-2.614v2.091h3.325v1.108h-4.716V40.987h4.716V42.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M204.874,48.463h-1.255a.554.554,0,0,1-.523-.272L201.528,45.8a.575.575,0,0,0-.188-.2.659.659,0,0,0-.314,0h-.6v2.928h-1.391V40.987h2.279a4.611,4.611,0,0,1,1.307.157,2.509,2.509,0,0,1,.9.45,1.746,1.746,0,0,1,.512.68,2.415,2.415,0,0,1,.167.868,2.352,2.352,0,0,1-.115.711,2.091,2.091,0,0,1-.324.617,2.238,2.238,0,0,1-.512.481,3.032,3.032,0,0,1-.7.324l.24.178A.952.952,0,0,1,203,45.7ZM201.3,44.553a2.143,2.143,0,0,0,.68-.1,1.223,1.223,0,0,0,.481-.272,1.1,1.1,0,0,0,.282-.408,1.5,1.5,0,0,0,.094-.523,1.046,1.046,0,0,0-.376-.878,1.788,1.788,0,0,0-1.15-.3h-.889v2.489Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M71.54,16.97h3.743l7.842,11.983V16.97H87.9V36.763H84.128l-7.8-11.951V36.763H71.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M91.124,32.413v-10.7a4.287,4.287,0,0,1,1.443-3.639,5.531,5.531,0,0,1,3.471-1.108q4.58,0,8.94.366v3.9H97.47a1.767,1.767,0,0,0-1.161.345,1.265,1.265,0,0,0-.418,1.046v2.185l7.737.272v3.628l-7.737.24v2.091a1.61,1.61,0,0,0,.4,1.192,1.474,1.474,0,0,0,1.046.387h7.654v3.869a85.007,85.007,0,0,1-8.637.45q-5.228,0-5.228-4.569"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M110.906,36.125a5.322,5.322,0,0,1-2.771-2.969,21.518,21.518,0,0,1,0-12.547,5.343,5.343,0,0,1,2.771-2.98,15.433,15.433,0,0,1,9.808,0,5.343,5.343,0,0,1,2.771,2.98,21.518,21.518,0,0,1,0,12.547,5.364,5.364,0,0,1-2.771,2.969,15.433,15.433,0,0,1-9.808,0m7.319-3.8a2.666,2.666,0,0,0,1.129-1.725,15.413,15.413,0,0,0,.335-3.733,16.113,16.113,0,0,0-.335-3.816,2.53,2.53,0,0,0-1.2-1.694,4.925,4.925,0,0,0-2.384-.439,4.841,4.841,0,0,0-2.363.439,2.624,2.624,0,0,0-1.129,1.694,15.589,15.589,0,0,0-.345,3.816,15.957,15.957,0,0,0,.324,3.733,2.719,2.719,0,0,0,1.14,1.725,6.274,6.274,0,0,0,4.747,0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 8.563,
    height: 3.68,
    transform: "translate(126.109 27.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M134.882,16.97h4.935l4.308,14.806,4.308-14.806h4.893l-6.274,19.793h-5.96Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 4.778,
    height: 19.793,
    transform: "translate(155.218 16.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M163.332,16.97h3.785l7.842,11.983V16.97h4.778V36.763h-3.806L168.09,24.812V36.763h-4.757Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M185.729,36.125a5.353,5.353,0,0,1-2.468-3,17.7,17.7,0,0,1-.868-6.274,16.469,16.469,0,0,1,.9-6.169,5.552,5.552,0,0,1,2.52-3.032,8.752,8.752,0,0,1,4.088-.836,21.957,21.957,0,0,1,3.785.293,15.181,15.181,0,0,1,2.792.711V21.4a30.929,30.929,0,0,0-5.552-.491,4.716,4.716,0,0,0-2.269.439A2.677,2.677,0,0,0,187.527,23a14.439,14.439,0,0,0-.355,3.785,16.573,16.573,0,0,0,.3,3.733,2.624,2.624,0,0,0,1.046,1.725,4.569,4.569,0,0,0,2.374.5,42.514,42.514,0,0,0,5.531-.272v3.576a20.724,20.724,0,0,1-6.6.826,9.41,9.41,0,0,1-4.182-.795"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 4.778,
    height: 19.793,
    transform: "translate(199.154 16.97)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M5.563,19.532S24.54,17.5,24.843,28.712s.387,24.613.387,24.613l2.311-11.5,2.206,11.5.575-24.613s-.941-10.08,19.27-9.327c-7.57-.805-16.029-2.321-22.031.763C24.833,19.009,23.254,17.158,5.563,19.532Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M48.421,10.592c-14.962,3.482-20.8,9.536-20.839,9.567s-5.845-6.085-20.839-9.567c0,0,35.6,10.916,6.985,39.241,0,0,11.313-7.549,13.854-12.777,2.541,5.228,13.865,12.777,13.865,12.777C12.829,21.508,48.421,10.592,48.421,10.592Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M51.893,14.847v4.841A25.617,25.617,0,1,1,2.5,21.957V16.071a27.489,27.489,0,1,0,49.394-1.223Z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M27.489,1.872A25.492,25.492,0,0,1,43.434,7.466h2.854a27.405,27.405,0,0,0-37.735.125h2.834a25.513,25.513,0,0,1,16.1-5.719Z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M27.447,8.647a4.078,4.078,0,0,0-1.788.418h3.618A3.9,3.9,0,0,0,27.447,8.647Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M32.1,9.065a6.033,6.033,0,0,1,.972,1.872H48.589V53.106H6.4V10.937H21.811a5.845,5.845,0,0,1,.983-1.872H4.517V54.977H50.45V9.065Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M29.277,9.065a4.046,4.046,0,1,0,1.84,1.872,4.046,4.046,0,0,0-1.84-1.872Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeoBlack);
export default __webpack_public_path__ + "static/media/neo_black.edb84a3fb5e86fb2e6d706336b806adc.svg";
export { ForwardRef as ReactComponent };